import React from 'react';
import { FadeIn, CTAButton } from './ui';
import { ArrowRightCircle, XCircle } from 'lucide-react';
export function FinalCTA() {
  return <section id="final-cta" className="py-24 px-4 bg-brand-darker relative border-t border-white/5 overflow-hidden" data-id="element-26">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-64 bg-brand-red/10 blur-[100px] pointer-events-none" data-id="element-27" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-28">
        <FadeIn data-id="element-29">
          <h2 className="font-bebas text-5xl md:text-6xl text-center text-white mb-16" data-id="element-30">
            Tienes <span className="text-brand-orange" data-id="element-31">dos caminos</span>:
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-32">
          <FadeIn delay={0.1} data-id="element-33">
            <div className="bg-black/50 border border-white/5 p-8 rounded-2xl h-full opacity-70" data-id="element-34">
              <XCircle className="w-10 h-10 text-zinc-500 mb-6" data-id="element-35" />
              <p className="text-lg text-zinc-400" data-id="element-36">
                Seguir como vas, sintiéndote cada vez más viejo, cansado y
                desconectado de tu familia.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-37">
            <div className="bg-brand-card border border-brand-orange/30 p-8 rounded-2xl h-full shadow-lg shadow-brand-orange/5" data-id="element-38">
              <ArrowRightCircle className="w-10 h-10 text-brand-orange mb-6" data-id="element-39" />
              <p className="text-lg text-white font-medium" data-id="element-40">
                Invertir $27 hoy y recuperar la vitalidad que necesitas para
                conquistar este país.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} className="text-center" data-id="element-41">
          <CTAButton className="w-full md:w-auto text-xl md:text-2xl py-6 px-12" href="https://guiasparavivir.com/cart/52612730781985:1" data-id="element-42" />
        </FadeIn>
      </div>
    </section>;
}